import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import {
  findCurrentStep,
  findPreviousStep,
  findCurrentStepIndex,
  mapCompleteSteps,
  getTotalSteps,
  getAllResultsArray,
  getAllResults,
  parseAndCalculatePrice,
  getAttributeValuesInResults,
  getDeepestAttributeValueInResults
} from "../utils/stepsToolbox";

Vue.use(Vuex);

export default () =>
  new Vuex.Store({
    state: {
      steps: null
    },
    getters: {
      currentStep: state => {
        return findCurrentStep(state.steps);
      },
      previousStep: state => {
        return findPreviousStep(state.steps);
      },
      getCalculation: state => {
        return state.steps.result ? state.steps.result.calculation : "";
      },
      totalPrice: (state, getters) => {
        return parseAndCalculatePrice(state.steps, getters.getCalculation);
      },
      currentStepIndex: state => {
        return findCurrentStepIndex(state.steps) - 1;
      },
      totalSteps: state => {
        return getTotalSteps(state.steps) - 1;
      },
      allResultsArray: state => {
        return getAllResultsArray(state.steps);
      },
      allResults: state => {
        return getAllResults(state.steps);
      },
      allResultsEffect: state => {
        return getAllResults(state.steps, 1, "name", "effect");
      },
      compareTypeResults: state => {
        return state.comparedOutcomes;
      },
      outcomeType: state => {
        if (state.steps) {
          return state.steps.outcomeType
            ? state.steps.outcomeType
            : "calculation";
        }
      },
      banner: state => {
        return state.steps && state.steps.banner ? state.steps.banner : false;
      },
      dataJson: state => {
        return state.steps.dataJson ? state.steps.dataJson : false;
      },
      resultLeftForm: state => state.steps.resultLeftForm,
      resultRightForm: state => state.steps.resultRightForm,
      resultMediaForm: state => state.steps.resultMediaForm,
      resultTitle: state => state.steps.resultTitle,
      resultSubtitle: state => state.steps.resultSubtitle,
      noResultTitle: state => state.steps.noResultTitle,
      noResultSubtitle: state => state.steps.noResultSubtitle,
      noResultContent: state => state.steps.noResultContent,
      nextStepLabel: state => state.steps.nextStepLabel,
      resultLoadingLabel: state => {
        if (state.steps.resultLoadingLabel != null) {
          return state.steps.resultLoadingLabel;
        } else {
          return "Je calcule votre prix...";
        }
      },
      attributeValues: state => {
        return attributeName =>
          getAttributeValuesInResults(state.steps, attributeName);
      },
      deepestAttributeValueInResults: state => {
        return attributeName =>
          getDeepestAttributeValueInResults(state.steps, attributeName);
      }
    },
    mutations: {
      initJsonStepsData(state, { jsonStepsData }) {
        Vue.set(state, "steps", Object.assign({}, jsonStepsData));
        Vue.set(state, "initialSteps", JSON.stringify(jsonStepsData));
      },
      resetJsonStepsData(state) {
        Vue.set(state, "steps", JSON.parse(state.initialSteps));
      },
      setCurrentStepResult(state, { currentStep, option }) {
        Vue.set(currentStep, "result", option);
      },
      unsetLastResult(state, { previousStep }) {
        Vue.set(previousStep, "result", null);
      },
      setComparedOutcomes(state, { comparedOutcomes }) {
        Vue.set(state, "comparedOutcomes", comparedOutcomes);
      }
    },
    actions: {
      initData({ commit }, { vm }) {
        commit("initJsonStepsData", { jsonStepsData: vm.jsonStepsData });
      },
      submitOption({ commit, getters }, option) {
        commit("setCurrentStepResult", {
          currentStep: getters.currentStep,
          option
        });

        if (getters.currentStep && getters.currentStep.skipConditions) {
          const previousResult = getters.allResultsArray.find(result => {
            return (
              result.name === getters.currentStep.skipConditions[0].skipName
            );
          });

          if (
            previousResult.result.effect ===
            getters.currentStep.skipConditions[0].skipEffect
          ) {
            commit("setCurrentStepResult", {
              currentStep: getters.currentStep,
              option: {
                effect: getters.currentStep.skipConditions[0].effect
              }
            });
          }
        }
      },
      navigateBack({ commit, getters }) {
        commit("unsetLastResult", {
          previousStep: getters.previousStep
        });
      },
      restart({ commit }) {
        commit("resetJsonStepsData");
      },
      compareOutcomes({ state, commit }) {
        if (
          state.steps != null &&
          state.steps.outcomeType == "compare" &&
          state.steps.outcomeJson != null
        ) {
          axios.get(state.steps.outcomeJson).then(response => {
            const fetchedOutcomes = response.data;
            const selectedMetas = mapCompleteSteps(state.steps, step => {
              if (step.meta != null) {
                return {
                  meta: step.meta,
                  value: step.result.effect
                };
              } else {
                return null;
              }
            });
            const comparedOutcomes = fetchedOutcomes.filter(fetchedOutcome => {
              let match = true;
              selectedMetas.forEach(selectedMeta => {
                if (
                  fetchedOutcome[state.steps.meta_field][selectedMeta.meta] !=
                  selectedMeta.value
                ) {
                  match = false;
                }
              });
              return match;
            });
            commit("setComparedOutcomes", { comparedOutcomes });
          });
        } else {
          commit("setComparedOutcomes", { comparedOutcomes: [] });
        }
      }
    },
    modules: {}
  });
